import { useState, useEffect } from "react";
import NetworkAPI from "../../../api/NetworkAPI";

const useFetchNetwork = (userId = null) => {
	const [loading, setLoading] = useState(false);
	const [network, setNetwork] = useState([]);

	const fetchNetwork = async () => {
		setLoading(true);
		try {
			const result = await NetworkAPI.getNetwork(userId);
			setNetwork(result);
		} catch (error) {
			console.error("Failed to fetch network:", error);
			setNetwork([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchNetwork();
	}, [userId]); // re-fetch whenever userId changes.

	return {
		network,
		loading,
		refetch: fetchNetwork,
	};
};

export default useFetchNetwork;
